import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Assuming you have this
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"; // <-- ADD THIS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}> {/* <-- WRAP YOUR APP */}
    <App />
  </BrowserRouter>
);

reportWebVitals();
